import React from "react";
import btnHome from '../images/btnHomeIcon.png';

const Language2 = () => {
  return (
    <div className="topicSection">

      {/* HOME BUTTON SECTION */}
      <div className="btnHomeSection bounce-in-fwd10">
        <button type="button" className="btnCircle">
          <img src={btnHome} alt="Date" height="50" width="50" /><br />
          HOME
        </button>
      </div>


      <div className="headerSub">
        <div className="headerSubTitle scale-in-center">
          <p>
            PLEASE SELECT YOUR PREFERRED LANGUAGE
          </p>
        </div>
      </div>

      <div className="headerName">
        <div className="headerTitle">
          {/* <h1>
            <div className="iconWard"></div>
            WARD VISIT
            </h1> */}
        </div>
      </div>


      {/* MAIN CONTENT SECTION */}
      <div className="contentPage">

        {/* BUTTON OPTIONS */}
        <div className="optionSectionA">
          <button type="button" className="btnslanted btnslantedW6 spaceTopBtmA fade-in-leftBtn2">
            ENGLISH
          </button>

          <button type="button" className="btnslanted btnslantedW6 spaceTopBtmA fade-in-leftBtn3">
            Bahasa Melayu
          </button>

          <button type="button" className="btnslanted btnslantedW6 spaceTopBtmA fade-in-leftBtn4">
            中文
          </button>

          <button type="button" className="btnslanted btnslantedW6 spaceTopBtmA fade-in-leftBtn5">
            தமிழ்
          </button>
        </div>



        {/* ICON BOX */}
        <div className="advertSize flip-in-hor-top2">
          <span>ADVERTISEMENTS <br /> (972x611)</span>
        </div>


        {/* SCROLLING MESSEGE */}
        <div className="scrollingSection slide-in-bottom3">
          <marquee behavior="scroll" direction="left">Here is some scrolling text... right to left!</marquee>
        </div>


      </div>

    </div>
  );
};

export default Language2;